import { LEARNING_SEQUENCE_LESSON_MATERIAL_GROUP_TYPE_GROUP } from 'global/constants';
import { BoxList } from 'approot/shared/styles/box.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import TooltipInfo from 'approot/shared/tooltip/tooltip-info';
import { LessonMaterialFragment } from './__generated__/LessonMaterialFragment';
import { LessonMaterialTextItalic } from './lesson-materials-list.style';
import {
  getMaterialUnitOfMeasurement,
  getPluralizedUnitOfMeasurement,
} from 'approot/activity-builder/components/teaching-notes/lesson-materials/units-of-measurement/units-of-measurement-utils';
import LessonMaterialsAlternatives from './lesson-materials-alternatives';

type Props = {
  list: LessonMaterialFragment[] | null;
};

const LessonMaterialsList = ({ list }: Props) => {
  return list?.length ? (
    <BoxList>
      {list.map((material, index) => {
        const unitOfMeasurementNameSingular =
          getMaterialUnitOfMeasurement(material)?.name || '';
        const unitOfMeasurementPluralized = getPluralizedUnitOfMeasurement(
          unitOfMeasurementNameSingular,
          material.numberOfItems
        );
        return (
          <PStyled
            key={`${index}-${material.id}`}
            as="li"
            data-selector="activity-material-card-details"
          >
            <span data-selector="activity-material-name">{material.name}</span>
            {material.note && (
              <TooltipInfo hoverText={material.note} multiline />
            )}
            {material.isOptional ? (
              <LessonMaterialTextItalic data-selector="activity-material-optional-keyword">
                {` Optional`}
              </LessonMaterialTextItalic>
            ) : null}

            <PStyled
              marginBottom={2}
              data-selector="activity-material-quantity-view"
            >
              {`${material.numberOfItems}${
                unitOfMeasurementPluralized
                  ? ` ${unitOfMeasurementPluralized}`
                  : ''
              } per ${material.groupType}${
                material.groupType ===
                LEARNING_SEQUENCE_LESSON_MATERIAL_GROUP_TYPE_GROUP
                  ? ` of ${material.numberInGroup}`
                  : ''
              }`}
            </PStyled>
            {!!material.alternativeMaterials?.length && (
              <LessonMaterialsAlternatives
                alternativeMaterials={material.alternativeMaterials}
                dataSelector="alternative-materials-view"
              />
            )}
          </PStyled>
        );
      })}
    </BoxList>
  ) : null;
};

export default LessonMaterialsList;
